module.exports = __webpack_public_path__ + "images/emoji/postbox.9ec61e091183a5d8312b.png";